<template>
  <div id="app" class="w-full h-full">
    <Loader :loading="mainLoading" v-if="mainLoading" fullscreen target="body" lock/>
    <Admin v-else-if="isLoggedIn"/>
  </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
import {MAIN_LOADING} from '@/store';
import Admin from '@/views/Admin';
import Loader from "@/components/ui/Loader";

export default {
  name: 'App',
  components: {
    Loader,
    Admin
  },
  computed: {
      ...mapState(['isLoggedIn', "mainLoading"])
  },
  methods: {
      ...mapMutations({
          mainLoadingFn: MAIN_LOADING
      })
  }
}
</script>

<style>
</style>
